import { render } from "./DutyScheduleCalendar.vue?vue&type=template&id=3521e4c5&scoped=true&ts=true"
import script from "./DutyScheduleCalendar.vue?vue&type=script&lang=ts"
export * from "./DutyScheduleCalendar.vue?vue&type=script&lang=ts"

import "./DutyScheduleCalendar.vue?vue&type=style&index=0&id=3521e4c5&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3521e4c5"]])

export default __exports__